import { Dropdown } from '@cbhq/cds-web/dropdown';
import { PopoverContentPositionConfig } from '@cbhq/cds-web/overlays';

const contentPosition = {
  placement: 'bottom-end',
  gap: 1,
} as PopoverContentPositionConfig;

type NavigationDropdownProps = {
  content: React.ReactNode;
  value?: string | undefined;
  children: React.ReactNode;
  testID: string;
  onChange?: (value: string) => void;
};

export function NavigationDropdown({
  content,
  value,
  children,
  testID,
  onChange,
}: NavigationDropdownProps) {
  return (
    <Dropdown
      content={content}
      value={value}
      testID={testID}
      enableMobileModal
      contentPosition={contentPosition}
      maxHeight={800}
      showOverlay
      onChange={onChange}
    >
      {children}
    </Dropdown>
  );
}
